import axios from "../axiosInstance";
import { UpdateTradeRevenueRequest } from "./types";

export const updateTradeRevenue = async (
  data: UpdateTradeRevenueRequest
): Promise<void> => {
  await axios.put("/api/private/my-company-profile/trade-revenue", data);
};
